export const SAVE_TOKEN = 'pages/login/SAVE_TOKEN'
export const LOGIN_REQUEST = 'pages/login/LOGIN_REQUEST'
